import { createSelector } from 'reselect'

import { NetworkContentRootState } from '../networkContentRoot.reducer'

export const getInstagramFeeds = createSelector(
  (state: NetworkContentRootState) => state.instagramStore.instagramFeeds,
  (state) => state,
)
